import React, { useRef } from 'react';
import { Megaphone, PhoneCall, FileBarChart2 } from 'lucide-react';
import { OFFER, OFFER_FOOTNOTE, OfferItem } from '../data/site';
import OfferDemoAds from './OfferDemoAds';
import OfferDemoCalls from './OfferDemoCalls';
import OfferDemoReport from './OfferDemoReport';
import { OfferDemoHandle } from './OfferDemoShared';

const ICONS = [Megaphone, PhoneCall, FileBarChart2];
const DEMOS = [OfferDemoAds, OfferDemoCalls, OfferDemoReport];

/**
 * The "what you get" grid. Each card's demo shows the system actually doing
 * that job (a real ad cycling, a real missed-call-to-booking thread, a real
 * report filling in) instead of a decorative placeholder. Each demo plays
 * once when it scrolls into view and carries its own Replay button. (Hover
 * no longer restarts it: blanking a finished card under the cursor read as
 * a glitch.)
 */
const OfferGrid: React.FC = () => {
  const demoRefs = useRef<Array<OfferDemoHandle | null>>([]);

  return (
    <div className="offer">
      {OFFER.map((o: OfferItem, i) => {
        const Icon = ICONS[i] ?? Megaphone;
        const Demo = DEMOS[i] ?? OfferDemoAds;
        return (
          <div className="offer__item" key={o.name}>
            <span className="offer__icon">
              <Icon width={22} height={22} strokeWidth={1.75} aria-hidden="true" />
            </span>
            <h3 className="offer__name">{o.name}</h3>
            <p className="offer__body">{o.body}</p>
            <Demo
              ref={(el) => {
                demoRefs.current[i] = el;
              }}
            />
          </div>
        );
      })}
      <p className="offer__footnote">{OFFER_FOOTNOTE}</p>
    </div>
  );
};

export default React.memo(OfferGrid);
